export default "__VITE_ASSET__D9iv29Lz__"